import { useTerminalsState } from "@/States/Terminals";
import { LibraryPageContext } from "@/pages/library_v2/components/filesView/context";
import { isSafeFileName } from "@/pages/library_v2/components/filesView/utils";
import { useTrans } from "@/translations";

import { useCallback, useContext, useMemo, useState } from "react";

import { twMerge } from "tailwind-merge";

export const CreateFolderView: React.FC = () => {
  const { t } = useTrans();
  const { currentTerminal } = useTerminalsState();
  const { refetchFolders, createFolder } = useContext(LibraryPageContext);
  const [newFolderName, setNewFolderName] = useState("");

  const isNewFolderNameValid = useMemo(
    () => isSafeFileName(newFolderName),
    [newFolderName],
  );

  const onAddFolder = useCallback(async () => {
    const trimmed = newFolderName.trim();
    if (!trimmed || !isSafeFileName(trimmed)) return;
    setNewFolderName("");

    await createFolder({
      terminalId: currentTerminal?.id!,
      folderName: trimmed,
    });
    // create new folder
    setNewFolderName("");
    refetchFolders();
  }, [createFolder, currentTerminal?.id, newFolderName, refetchFolders]);

  return (
    <div className="mt-[9px] flex flex-col gap-[3px] border-t border-[#F1EAEA] pt-[10px]">
      <div className="flex gap-[6px]">
        <input
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onAddFolder();
          }}
          placeholder={t("libraryPage:folderListNewFolder")}
          className={twMerge(
            "min-w-0 flex-1 rounded border px-[9px] py-[7px] text-[12.5px] outline-none",
            !isNewFolderNameValid && newFolderName.length
              ? "border-red-500"
              : "border-grey3",
          )}
        />
        <button
          type="button"
          onClick={onAddFolder}
          disabled={!isNewFolderNameValid}
          className="cursor-pointer rounded bg-black px-[11px] py-[7px] text-[12px] font-semibold text-white disabled:cursor-not-allowed disabled:opacity-40"
        >
          {t("libraryPage:folderListNewFolderAdd")}
        </button>
      </div>
      {!isNewFolderNameValid && !!newFolderName.length && (
        <span className="text-[11px] font-normal text-red-500">
          {t("libraryPage:folderNameInvalidChars")}
        </span>
      )}
    </div>
  );
};
